<div class="list-header">
  <list-header class="width-20" [identifier]="'Identifier'" [sorting]="sorting" (sort)="onSort($event)"></list-header>
  <list-header class="width-20" [identifier]="'startdate'" [sorting]="sorting" (sort)="onSort($event)"></list-header>
  <list-header class="width-20" [identifier]="'enddate'"></list-header>
  <list-header class="width-20" [identifier]="'Status'" [sorting]="sorting" (sort)="onSort($event)"></list-header>
  <list-header class="width-20" [identifier]="'Execution'"></list-header>
</div>
<cdk-accordion *ngIf="objects | async as closures">
  <cdk-accordion-item *ngFor="let closure of closures; let index = index"
      #accordionItem="cdkAccordionItem" expanded="{{index == selection}}" role="button" tabindex="0" [attr.id]="'header-' + index">
    <div [class]="'list-item' + (selection == index ? ' selected' : '')" (click)="onToggle(accordionItem, index)">
      <span class="width-20">{{closure.identifier}}</span>
      <span class="width-20">{{closure.startDate | datestamp}}</span>
      <span class="width-20">{{closure.endDate | datestamp}}</span>
      <span class="width-20">{{'closure.' + closure.status | translate}}</span>
      <span class="width-20">{{closure.executionDate | datestamp}}</span>
    </div>
    <div *ngIf="accordionItem.expanded" role="region" [style.display]='' [attr.id]="'body-' + index">
      <app-closure-form [object]="closure" [undo]="closure.id == id ? 'undo' : ''" (objectChange)="onUpdate(index, $event)" (event)="onEvent($event)"></app-closure-form>
    </div>
  </cdk-accordion-item>
</cdk-accordion>
<div class="count"><span *ngIf="total | async as total">{{count | async}} / {{total}}</span></div>
